import { createApp } from 'vue'
import StreamDonationOverviewHorizontal from './StreamDonationOverviewHorizontal'

const el = '.kb-component--stream-donation-overview-horizontal'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StreamDonationOverviewHorizontalDOM) => {
            const variation = StreamDonationOverviewHorizontalDOM.dataset.variation || 'dark'
            const fundraisingId = StreamDonationOverviewHorizontalDOM.dataset.fundraisingId || ''
            const footerText = StreamDonationOverviewHorizontalDOM.dataset.footerText || ''
            const minNyDonationSek = parseInt(StreamDonationOverviewHorizontalDOM.dataset.minNyDonationSek, 10) || 2
            const maxNyDonationSek = parseInt(StreamDonationOverviewHorizontalDOM.dataset.maxNyDonationSek, 10) || 10
            const donationStyle = StreamDonationOverviewHorizontalDOM.dataset.donationStyle || 'normal'
            const component = createApp(StreamDonationOverviewHorizontal, {
                variation,
                fundraisingId,
                footerText,
                minNyDonationSek,
                maxNyDonationSek,
                donationStyle
            }).use(Store)
            component.mount(StreamDonationOverviewHorizontalDOM)
        })
    }
}
